export default "__VITE_ASSET__0ce78e68__"